var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import cls from 'classnames';
import { Dialog, Form, tools } from 'rcm-mobile';
import './style/index.scss';
let getUuid;
let rootElement;
const formDialogInstance = {};
/**
 * @author sayll
 * @version 0.0.1
 */
export default class FormDialog extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.refForm = React.createRef();
    }
    get form() {
        return this.refForm.current;
    }
    render() {
        const { prefixCls, className, children } = this.props;
        return <Form ref={this.refForm} className={cls(prefixCls, className)}>{children}</Form>;
    }
    static create(content, title, callback, options) {
        getUuid = getUuid || tools.helper.getUuidFn(FormDialog.defaultProps.prefixCls);
        if (!rootElement) {
            rootElement = document.createElement('div');
            rootElement.className = `${FormDialog.defaultProps.prefixCls}-root`;
            document.body.appendChild(rootElement);
        }
        const key = getUuid();
        const refFormDialog = React.createRef();
        const sender = Dialog.create(<FormDialog ref={refFormDialog}>{content}</FormDialog>, title, undefined, Object.assign({ onOk: () => callback && callback(refFormDialog.current), onBeforeOk: () => refFormDialog.current.form.reportValidity().every((item) => item.valid) }, options));
        return formDialogInstance[key] = sender;
    }
    /**
     * 消息框
     * @public
     * */
    static alert(content, title, callback, options) {
        return FormDialog.create(content, title, callback, Object.assign({ type: 'alert' }, options));
    }
    /**
     * 对话框
     * @public
     * */
    static confirm(content, title, callback, options) {
        return FormDialog.create(content, title, callback, Object.assign({ type: 'confirm' }, options));
    }
    /**
     * 卸载所有FormDialog
     * @public
     * */
    static destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            let sender;
            for (let key in formDialogInstance) {
                sender = yield formDialogInstance[key];
                sender.destroy();
                delete formDialogInstance[key];
            }
        });
    }
}
FormDialog.defaultProps = {
    prefixCls: 'x-form-dialog'
};
